export type SessionPrewarmMode = "standard" | "acquisition-fresh-on-start";

export type ShouldPrewarmInput = {
  enabled: boolean;
  mode?: SessionPrewarmMode;
  authLoading?: boolean;
  selectedLanguageCode?: string | null;
  podcastDiscussionId?: string | null;
};

/**
 * Pure policy for deciding whether a session is eligible for background prewarm.
 * Acquisition demos always use a fresh connection created by an explicit Start.
 */
export function shouldPrewarm({
  authLoading = false,
  enabled,
  mode = "standard",
  podcastDiscussionId,
  selectedLanguageCode,
}: ShouldPrewarmInput): boolean {
  if (!enabled || authLoading || !selectedLanguageCode || podcastDiscussionId) {
    return false;
  }

  return mode !== "acquisition-fresh-on-start";
}
